
import * as ipxRuntime$cB9CXqxSzpIuuXmfnlwuVBzDu4UHlKQAcn_45z489B9Gg from '/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {
    "listing": {
      "modifiers": {
        "height": 227,
        "fit": "fill",
        "format": "webp"
      }
    }
  },
  "provider": "ipx",
  "domains": [
    "bio-circle-backend.go2flow.dev",
    "cp.bio-circle.ch"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ],
  "quality": 80
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$cB9CXqxSzpIuuXmfnlwuVBzDu4UHlKQAcn_45z489B9Gg, defaults: {} }
}
        